import esriId from "@arcgis/core/identity/IdentityManager.js";
import Map from "@arcgis/core/Map.js";
import MapView from "@arcgis/core/views/MapView.js";
import SpatialReference from "@arcgis/core/geometry/SpatialReference.js";
import Extent from "@arcgis/core/geometry/Extent.js";
import TileLayer from "@arcgis/core/layers/TileLayer.js";
import Basemap from "@arcgis/core/Basemap.js";
import BasemapToggle from "@arcgis/core/widgets/BasemapToggle.js";
import LayerList from "@arcgis/core/widgets/LayerList.js";
import Legend from "@arcgis/core/widgets/Legend.js";
import Expand from "@arcgis/core/widgets/Expand.js";
import Search from "@arcgis/core/widgets/Search.js";
import Home from "@arcgis/core/widgets/Home.js";
import SketchViewModel from "@arcgis/core/widgets/Sketch/SketchViewModel.js";


import {graphicsLayer, netwerkLayer, D1, tweeD} from "./MapLayers";


const mapFunctions = function (setHasData,setWater,setHouses) {
 
    const token = "-3fBX4Kia8Tf6_1odhE-lql9fOZM0N3daAKwT_Y07GUUnJnqMBrdn2L1sIN5psuoxqkkS9xTB3LVNnKpb88e1uRY4xUnC_FYRejm51W4I2EIJjQnn7z7jz8zplkLMwIq";
    var id = {
        serverInfos: [],
        oAuthInfos: [],
        credentials: [
            {
                server: "https://ags.witteveenbos.com/wb/",
                token: token,
                expires: 1821787103639,
                ssl: true,
                scope: "server"
            }
        ]
    };

    
    esriId.initialize(id);

    // RD start extent
    const srRD = new SpatialReference({ wkid: 28992 });
    const startext = new Extent({
        xmin: 126100,
        ymin: 393500,
        xmax: 139900,
        ymax: 403300,
        spatialReference: srRD
    });

    const mapBaseLayerbasemapTopoBasisNL = new TileLayer({
        url: "https://services.arcgisonline.nl/arcgis/rest/services/Basiskaarten/Topo/Mapserver"
    });
    const basemapTopoBasisNL = new Basemap({
        baseLayers: [mapBaseLayerbasemapTopoBasisNL],
        title: "topo basis",
        id: "topo_basis",
        thumbnailUrl: "/basemap_topographic.jpg"
    });

    var mapBaseLayerbasemapLufoNL = new TileLayer({
        url: "https://services.arcgisonline.nl/arcgis/rest/services/Luchtfoto/Luchtfoto/Mapserver"
    });
    var basemapLuchtfotoNL = new Basemap({
        baseLayers: [mapBaseLayerbasemapLufoNL],
        title: "luchtfoto",
        id: "luchtfoto",
        thumbnailUrl: "/basemap_imagery.jpg"
    });

    const map = new Map({
        basemap: basemapTopoBasisNL
    });

    const view = new MapView({
        container: "viewDiv",
        map: map,
        extent: startext,
        zoom: 8,
        spatialReference: srRD,
        constraints: {
            //minZoom: 14,            // User cannot zoom out beyond a scale of 1:500,000
            //maxZoom: 7,             // User can overzoom tiles
            rotationEnabled: false  // Disables map rotation
        },
        highlightOptions: {
            color: [255, 255, 0, 1],
            haloOpacity: 0.9,
            fillOpacity: 0.2
        },
        popupEnabled: true,
        popup: {
            dockEnabled: false,
            dockOptions: {
                position: "auto",
                breakpoint: false
            }
        }
    });

    /********************
     * Add feature layer
     ********************/

    // NIEUW mei2026
    
    //---------------------------------------    
    const featureLayerList = [tweeD, D1];
  
    map.addMany(featureLayerList);

    //map.add(D1);
    map.add(netwerkLayer);
    map.add(graphicsLayer);

    // Zoeken
    const searchWidget = new Search({
        view: view,
        popupEnabled: true,
        locationEnabled: false
    });
    var SearchExpand = new Expand({
        view: view,
        group: "tilburg",
        content: searchWidget,
        expanded: false,
        collapseTooltip: "Zoek op adres",
        expandTooltip: "Sluit zoeken"
    });
    view.ui.add(SearchExpand, "top-right");

    // Home
    let homeWidget = new Home({
        view: view
    });
      
    // adds the home widget to the top left corner of the MapView
    view.ui.add(homeWidget, "top-left");

    // LayerList + legenda
    let layerWidget = new LayerList({
        view: view,
        listItemCreatedFunction: function (event) {
            const item = event.item;
            //if (item.layer.title == Algemeen.title) {
            item.panel = {
                content: "legend",
                open: false
            };
            //}
            //Expand the layer list
            if (!item.parent) {
                item.open = true;
            }
        },
        dragEnabled: true,
        visibilityAppearance: "checkbox"
    });
    var LayerExpand = new Expand({
        view: view,
        group: "tilburg",
        content: layerWidget,
        expanded: false,
        collapseTooltip: "Open de lagenlijst",
        expandTooltip: "Sluit de lagenlijst"
    });
    view.ui.add(LayerExpand, "top-right");
    //end  LayerList + legenda
    // -----
    // legenda
    let legendWidget = new Legend({
        view: view
    });
    var LegendExpand = new Expand({
        view: view,
        group: "tilburg",
        content: legendWidget,
        expanded: false,
        collapseTooltip: "Open de legenda",
        expandTooltip: "Sluit de legenda"
    });
    view.ui.add(LegendExpand, "top-right");
    //end  legenda

    // Basemap
    var Btoggle = new BasemapToggle({
        view: view,
        nextBasemap: basemapLuchtfotoNL
    });
    // Add
    view.ui.add(Btoggle, "bottom-left");


    /********************
     * Analyse tool
     ********************/
    // let featureLayerView = null;

    let featureLayerViewItems = []


    const addLayerViews = (layer) => {
        if (layer.type === "group") {
            layer.layers.forEach(addLayerViews);
        } else {
            view.whenLayerView(layer).then((layerView) => {
                if (layerView.layer.type === "feature" && layerView.layer.visible) {
                    featureLayerViewItems.push(layerView);
                }
            });
        }
    };

    featureLayerList.forEach(addLayerViews);

    var AnalyseExpand = new Expand({
        view: view,
        group: "tilburg",
        expandIcon: "edit-geometry",
        expandTooltip: "WoS analyse",
        content: document.getElementById("AnalyseTool"),
        expanded: true
    });
    view.ui.add(AnalyseExpand, "top-right");
    //---
    let sketchGeometry = null;
    const sketchViewModel = new SketchViewModel({
        view: view,
        layer: graphicsLayer,
        polygonSymbol: {
            type: "simple-fill",
            style: "cross",
            color: "#EFC8B1",
            outline: {
                width: 2,
                style: "solid",
                color: "#514644"
            }
        }
    });

    // check if the create event's state has changed to complete indicating
    // the graphic create operation is completed.
    sketchViewModel.on(["create"], async (event) => {
        // update the filter every time the user finishes drawing the filtergeometry
        if (event.state === "complete") {
            sketchGeometry = event.graphic.geometry;
            updateFilter();
        }
    });

    // check if the update event's state has changed to complete indicating
    // the graphic update operation is completed.
    sketchViewModel.on(["update"], async (event) => {
        // update the filter every time the user finishes updating the filtergeometry
        if (event.state === "complete") {
            sketchGeometry = event.graphics[0].geometry;
            updateFilter();
        }
    });

    // draw geometry buttons - use the selected geometry to sktech
    document.getElementById("polygonBtn").onclick = geometryButtonsClickHandler;
    function geometryButtonsClickHandler(event) {

        const geometryType = event.target.value;
        clearFilter();
        sketchViewModel.create(geometryType);
    }

    // remove the filter
    document.getElementById("clearFilter").addEventListener("click", clearFilter);

    function clearFilter() {
        setHasData(false)
        setHouses([])
        setWater([])
        sketchGeometry = null;
        graphicsLayer.removeAll();
        graphicsLayer.filter = null;
        // featureLayerView.filter = null;
        // totaalVolume.innerHTML = 0;
        featureLayerViewItems.forEach((layerView) => {
            if (layerView) {
                layerView.filter = null;
            }
        });
    }

    // set the geometry filter on the visible FeatureLayerView
    function updateFilter() {
        setHasData(false)
        setHouses([])
        setWater([])

        const featureFilter = {
            // autocasts to FeatureFilter
            geometry: sketchGeometry,
            spatialRelationship: "intersects"
        };

        featureLayerViewItems
        //  .filter(item => item.layer.visible && item.parent?.visible && item.parent?.parent?.visible && item.parent?.parent?.layer?.title === "Resultaten 2D")
            .filter(item => item.layer.visible && item.parent?.visible && item.parent?.parent?.visible )
            .sort((a, b) => {
            const titleA = a.parent?.parent?.layer?.title || '';
            const titleB = b.parent?.parent?.layer?.title || '';
            return titleA.localeCompare(titleB);
            })
            .forEach((layerView) => {
            if (layerView && layerView.layer.visible) {
                layerView.filter = featureFilter;
                if (layerView.layer.title.indexOf('water-op-straat') > -1) {
                const newData = queryLayerViewAgeStats(sketchGeometry, layerView);
                newData.then(waarde => {
                    setHasData(true);
                    let waterobject = {
                        scenario: layerView.parent?.parent?.layer?.title,
                        type: layerView.parent?.layer?.title,
                        kaartlaag: layerView.layer.title,
                        aantal: Math.round(waarde)
                    }
                    setWater(prevWater => [...prevWater, waterobject]);
                });
                } else if (layerView.layer.title.indexOf('risicopanden') > -1) {
                const houses = countHouses(sketchGeometry, layerView);
                houses.then(house => {
                    setHasData(true);
                    let houseobject = {
                        scenario: layerView.parent?.parent?.layer?.title,
                        type: layerView.parent?.layer?.title,
                        kaartlaag: layerView.layer.title,
                        aantal: house
                    }
                    setHouses(prevHouse => [...prevHouse, houseobject]);
                });
                //console.log('huizen layer');
                } else {
                }
            }
            });
    }

    async function countHouses(buffer, layerView) {
        const query = layerView.createQuery();
        // query.outStatistics = sumDepth2D;
        query.geometry = buffer;
        const results = await layerView.layer.queryFeatureCount(query);
        return results;
        // console.log("Number of houses: " + results);

    }

    /*********************************************************************
    * Spatial query the feature layer view for statistics
    *********************************************************************/
    async function queryLayerViewAgeStats(buffer, layerView) {


        // Client-side spatial query:
        // Get a sum of WoS that intersect the polygon 
        const query = layerView.createQuery();
        query.geometry = buffer;
        query.outFields = ["DEPTH2D","Shape_Area"];
        query.returnGeometry = false;

        // Query the features on the client using FeatureLayerView.queryFeatures
        try {
            const results = await layerView.layer.queryFeatures(query);
            //console.log("Aantal features: "+ (results.features).length);
            //console.log("Features: ", results.features);
            let totvol = 0;
            for (let nr in results.features){
              let feat = results.features[nr];
              //console.log("DEPTH2D: "+ feat.attributes.DEPTH2D);        
              //console.log("AREA2D: "+ feat.attributes.Shape_Area);      
              let featvol = feat.attributes.DEPTH2D * feat.attributes.Shape_Area
              totvol = totvol + featvol;
              //console.log("Volume feature: "+ featvol+" m3");      
            }
            //console.log("Totaal volume = "+ totvol+" m3");      
            return totvol;
        } catch (error) {
            console.error("Query failed: ", error);
            return 0;
        }
    }
    /****************** */

    /*********************************************************************
    * Scenario kiezer obv de pulldowns.
    *********************************************************************/
    // Helper: maak een key van de 4 values (gebruik separator die niet in values voorkomt)
    function makeKey(a, b, c, d) {
        return [a, b, c, d].join('|');
    }

    var lookup = {
        // 1D scenario's
        "HS|B08|1D|": "HS_B08_1D",
        "HS|BC2|1D|": "HS_BC2_1D",
        "TS|B08|1D|": "TS_B08_1D",
        "TS|BC2|1D|": "TS_BC2_1D",
        // 2D scenario's
        // scenario's water op straat
        "HS|2D|BC2|WoS": "HS_2D_BC2_WoS",
        "HS|2D|B70|WoS": "HS_2D_B70_WoS",
        "TS|2D|BC2|WoS": "TS_2D_BC2_WoS",
        "TS|2D|B70|WoS": "TS_2D_B70_WoS",
        // 2D scenario's risico panden
        "HS|2D|BC2|RP": "HS_2D_BC2_RP",
        "HS|2D|B70|RP": "HS_2D_B70_RP",
        "TS|2D|BC2|RP": "TS_2D_BC2_RP",
        "TS|2D|B70|RP": "TS_2D_B70_RP",
        // gecombineerde scenario's
        "HS|2D|BC2|WoSRP": "HS_2D_BC2_WoSRP",        
        "HS|2D|B70|WoSRP": "HS_2D_B70_WoSRP",
        "TS|2D|BC2|WoSRP": "TS_2D_BC2_WoSRP",
        "TS|2D|B70|WoSRP": "TS_2D_B70_WoSRP"
    };

    let scenarioLoaded = false;

    // Event listener voor de knop
    let button = document.getElementById("SetScenario");
    button.addEventListener("click", SetScenario);

    const selects = document.querySelectorAll("#ScenarioTool select");

    function setDirty(isDirty, changedSelect = null) {
        if (isDirty) {
            // Alleen de gewijzigde pulldown toevoegen
            if (changedSelect) {
                changedSelect.classList.add("changed");
            }
            // Button rood
            button.classList.add("changed-button");
            button.title = "Er zijn wijzigingen. Klik om het nieuwe scenario te laden.";
        } else {
            // Alles resetten
            selects.forEach(s => s.classList.remove("changed"));
            button.classList.remove("changed-button");
            button.title = "Laad het geselecteerde scenario.";
        }
    }

    // Wijziging van een pulldown
    selects.forEach(select => {
        select.addEventListener("change", function () {
            if (!scenarioLoaded) return;
            setDirty(true, this);
        });
    });

    function SetScenario() {        
        const val1 = document.getElementById("selectScenarioPanel1").value;
        const val2 = document.getElementById("selectScenarioPanel2").value;
        const val3 = document.getElementById("selectScenarioPanel3").value;
        const val4 = document.getElementById("selectScenarioPanel4").value;

        var key = ""
        if (val4 === "1D") {
            key = makeKey(val2, val3, val4);
        } else {
            key = makeKey(val2, val4, val3, val1);
        }
        
        var result = lookup[key];
        if (result) {
            //console.log("Gevonden mapping voor", key, "->", result, "zoeken naar laagcode:", result);
            view.when().then(() => {
                // zet alles uit en zet laag met laagcode aan (gebruik result als laagcode)
                turnOffAllAndEnableByLaagcode(view.map, result);
                scenarioLoaded = true;
                setDirty(false);                
            });

        } else {
            console.warn("Geen mapping gevonden voor", key);
        }
    }
  
    // Zet alle lagen uit en zet laag met overeenkomende laagcode aan
    function turnOffAllAndEnableByLaagcode(map, laagcode) {
        if (!map || !map.layers) {
            console.warn("Map of map.layers niet beschikbaar");
            return;
        }

        // Recursief alle lagen uitschakelen (behalve speciale lagen)
        function turnOffAllLayers(layers) {
            if (!layers || typeof layers.forEach !== "function") return;

            layers.forEach(function(layer) {
                // Sla Analyse polygoon over (mag nooit uit)
                if (layer.title === "Analyse polygoon") {
                    return;
                }

                // Zet het layer uit (inclusief Netwerk!)
                if ("visible" in layer) {
                    layer.visible = false;
                }

                // Ga niet dieper in Netwerk (stop hier)
                if (layer.title === "Netwerk") {
                    return;
                }

                // Ga dieper in grouplayers (behalve hide-children)
                if (layer.layers && typeof layer.layers.forEach === "function") {
                    if (layer.listMode !== "hide-children") {
                        turnOffAllLayers(layer.layers);
                    }
                }

                // Ga dieper in sublayers (behalve hide-children)
                if (layer.sublayers && typeof layer.sublayers.forEach === "function") {
                    if (layer.listMode !== "hide-children") {
                        layer.sublayers.forEach(function(sublayer) {
                            if ("visible" in sublayer) {
                                sublayer.visible = false;
                            }
                            // Nested sublayers (zeer zelden)
                            if (sublayer.sublayers && typeof sublayer.sublayers.forEach === "function") {
                                sublayer.sublayers.forEach(function(nested) {
                                    if ("visible" in nested) {
                                        nested.visible = false;
                                    }
                                });
                            }
                        });
                    }
                }
            });
        }

        // Recursief zoeken naar laag met laagcode en inschakelen
        function findAndEnableByLaagcode(layers) {
            if (!layers || typeof layers.forEach !== "function") return false;

            for (let layer of layers) {
                // Check directe laagcode match
                if (layer.laagcode && layer.laagcode === laagcode) {
                    if ("visible" in layer) layer.visible = true;

                    // Zet alle layers aan (GroupLayers)
                    if (layer.layers && typeof layer.layers.forEach === "function") {
                        layer.layers.forEach(function(childLayer) {
                            if ("visible" in childLayer) childLayer.visible = true;
                        });
                    }

                    // Zet alle sublayers aan (MapImageLayers)
                    if (layer.sublayers && typeof layer.sublayers.forEach === "function") {
                        layer.sublayers.forEach(function(sublayer) {
                            if ("visible" in sublayer) sublayer.visible = true;
                            // Zet ook nested sublayers aan
                            if (sublayer.sublayers && typeof sublayer.sublayers.forEach === "function") {
                                sublayer.sublayers.forEach(function(nested) {
                                    if ("visible" in nested) nested.visible = true;
                                });
                            }
                        });
                    }
                    return true;
                }

                // Zoek in grouplayers
                if (layer.layers && typeof layer.layers.forEach === "function") {
                    if (findAndEnableByLaagcode(layer.layers)) {
                        if ("visible" in layer) layer.visible = true;
                        return true;
                    }
                }

                // Zoek in sublayers
                if (layer.sublayers && typeof layer.sublayers.forEach === "function") {
                    for (let sublayer of layer.sublayers) {
                        if (sublayer.laagcode && sublayer.laagcode === laagcode) {
                            if ("visible" in sublayer) sublayer.visible = true;
                            // Zet nested sublayers aan
                            if (sublayer.sublayers && typeof sublayer.sublayers.forEach === "function") {
                                sublayer.sublayers.forEach(function(nested) {
                                    if ("visible" in nested) nested.visible = true;
                                });
                            }
                            if ("visible" in layer) layer.visible = true;
                            return true;
                        }
                    }
                }
            }
            return false;
        }

        // Voer uit
        turnOffAllLayers(map.layers.toArray());

        if (!findAndEnableByLaagcode(map.layers.toArray())) {
            console.warn("Geen laag gevonden met laagcode:", laagcode);
        }
    }
    // *********************************************************************
    // *********************************************************************

};
export default mapFunctions;